import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoRepresentacaoInstituicaoGestora } from '../models/tipo-representacao-instituicao-gestora.model';

@Injectable({
  providedIn: 'root',
})
export class TipoRepresentacaoInstituicaoGestoraService {
  private readonly path = 'bolsa';

  constructor(private apiService: ApiService) {}

  // List all TipoRepresentacaoInstituicaoGestora
  list(): Observable<any> {
    return this.apiService
      .get<{ data: TipoRepresentacaoInstituicaoGestora[] }>(
        `${this.path}/getAllTipoRepresentacaoInstituicaoGestora`
      )
      .pipe(map((response) => response));
  }

  // Get TipoRepresentacaoInstituicaoGestora by ID
  public show(id: string): Observable<TipoRepresentacaoInstituicaoGestora> {
    return this.apiService
      .get<{ data: TipoRepresentacaoInstituicaoGestora }>(
        `${this.path}/getTipoRepresentacaoInstituicaoGestoraById/${id}`
      )
      .pipe(map((response) => response.data));
  }

  // Create new TipoRepresentacaoInstituicaoGestora
  public store(
    tipoRepresentacaoInstituicaoGestora: TipoRepresentacaoInstituicaoGestora
  ): Observable<TipoRepresentacaoInstituicaoGestora> {
    return this.apiService
      .post<{ object: TipoRepresentacaoInstituicaoGestora }>(
        `${this.path}/AddTipoRepresentacaoInstituicaoGestora`,
        tipoRepresentacaoInstituicaoGestora
      )
      .pipe(map((response) => response.object));
  }

  // Update existing TipoRepresentacaoInstituicaoGestora
  public update(
    tipoRepresentacaoInstituicaoGestora: TipoRepresentacaoInstituicaoGestora,
    id: string
  ): Observable<TipoRepresentacaoInstituicaoGestora> {
    return this.apiService
      .put<{ object: TipoRepresentacaoInstituicaoGestora }>(
        `${this.path}/UpdateTipoRepresentacaoInstituicaoGestora/${id}`,
        tipoRepresentacaoInstituicaoGestora
      )
      .pipe(map((response) => response.object));
  }

  // Delete existing TipoRepresentacaoInstituicaoGestora
  public delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteTipoRepresentacaoInstituicaoGestoraById/${id}`
    );
  }
}
